import type { ComponentProps } from 'react'

import { LifeRadioGroup } from './LifeRadioGroup'
import { LifeSelect } from './LifeSelect'

type DisplayType = 'radio' | 'select'

export type LifeEnumeratedInputProps<T> = (
  | ComponentProps<typeof LifeSelect<T>>
  | ComponentProps<typeof LifeRadioGroup<T>>
) & { displayType?: DisplayType }

export const LifeEnumeratedInput = <T,>({
  displayType = 'select',
  ...restProps
}: LifeEnumeratedInputProps<T>) => (
  <>
    {displayType === 'select' && <LifeSelect {...restProps} />}
    {displayType === 'radio' && <LifeRadioGroup {...restProps} />}
  </>
)
